import { render, staticRenderFns } from "./RechargeRecords.vue?vue&type=template&id=0c2448f2&scoped=true"
import script from "./RechargeRecords.vue?vue&type=script&lang=js"
export * from "./RechargeRecords.vue?vue&type=script&lang=js"
import style0 from "./RechargeRecords.vue?vue&type=style&index=0&id=0c2448f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2448f2",
  null
  
)

export default component.exports